export const getCourseState = (state: any) => state.course
